import type { UserPermissions } from "../SettingsPermissions/types/permissions.types.ts"

// Nav visibility, route access and tab content all resolve through the same
// two predicates below. They used to disagree: the route was gated on the
// `leads_archived` *page* while the Leads tab rendered on the
// `lead_view_archive` *code*, so a user holding only the former passed the
// gate and then fell through to the Leads tab anyway — reading an archive the
// old `/leads/inactive` route refused them. One signal per audience, used
// everywhere, is what keeps that from reopening.

// The exact signal `/leads/inactive` is gated by in lead-routes.tsx.
export const canSeeLeadsArchiveContent = (
  permissions?: UserPermissions | null
): boolean => !!permissions?.codes?.leads?.features?.lead_view_archive

// `project_archive` is what used to show the Active/Archive switch, but that
// switch only ever rendered *inside* the projects list — which is itself
// gated on the `projects` page (project-routes.tsx). The Archive tab mounts
// that same list, so it owes the same page permission; without it a user
// could reach the full project list, filters and row actions here having
// been refused `/projects/list`.
export const canSeeProjectsArchive = (
  permissions?: UserPermissions | null
): boolean =>
  !!permissions?.pages?.includes("projects") &&
  !!permissions?.codes?.projects?.features?.project_archive

// Whether the merged Archive destination should be reachable at all: exactly
// when at least one tab has something this user is allowed to read.
export const canAccessArchivePage = (
  permissions?: UserPermissions | null
): boolean =>
  canSeeLeadsArchiveContent(permissions) || canSeeProjectsArchive(permissions)
